/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useEffect } from 'react';

const useDialogNoScroll = (loader) => {
    // it will help to show a MUI dialog without scrolling the background
    useEffect(() => {
        if (typeof document !== 'undefined') {
            document?.getElementById('root')?.removeAttribute('aria-hidden');
        }
    }, [loader]);
};

export { useDialogNoScroll as default };
